import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CalendarModule as AngularCalendarModule, CalendarDateFormatter, CalendarMomentDateFormatter, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/moment';
import { CalendarComponent } from './components/calendar/calendar.component';

import { ButtonGroupModule, ButtonModule, ModalModule } from '@coreui/angular-pro';
import { I18nService, TranslationModule } from 'i18n';
import moment from 'moment';
import { CalendarNavigationComponent } from './components/calendar-navigation/calendar-navigation.component';
import { CalendarEvent, NULL_CALENDAR_EVENT, NullCalendarEvent } from 'calendar';

export function nullCalendarEventFactory(i18nService: I18nService): CalendarEvent {
  return new NullCalendarEvent(i18nService.getLanguage());
}

export function momentAdapterFactory() {
  return adapterFactory(moment);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ModalModule,
    ButtonModule,
    ButtonGroupModule,
    AngularCalendarModule.forRoot(
      {
        provide: DateAdapter,
        useFactory: momentAdapterFactory,
      },
      {
        dateFormatter: {
          provide: CalendarDateFormatter,
          useClass: CalendarMomentDateFormatter,
        }
      }
    ),
    TranslationModule
  ],
  declarations: [CalendarComponent, CalendarNavigationComponent],
  exports: [CalendarComponent, CalendarNavigationComponent],
  providers: [
    {
      provide: NULL_CALENDAR_EVENT, 
      useFactory: nullCalendarEventFactory,
      deps: [I18nService]
    }
  ]
})
export class CalendarModule {}